// extracted by mini-css-extract-plugin
export var disabled = "_s7-0";